import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { UnsubscribeService } from '@libs/shared/services/unsubscribe.service';
import { ButtonModule } from '@libs/shared/components/button/button.module';
import { ClientStore } from '@libs/shared/storage/client.store';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { ClientModel } from '@libs/models/client.model';
import { BankIdService } from '@libs/services/bank-id.service';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-verification-video',
  templateUrl: './verification-video.component.html',
  styleUrls: ['./verification-video.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [UnsubscribeService],
  imports: [ButtonModule, TranslateModule],
})
export class VerificationVideoComponent {
  public clientName: string;
  public isDisabled: boolean = false;

  constructor(
    private clientStore: ClientStore,
    private cd: ChangeDetectorRef,
    private service: BankIdService,
    private router: Router,
  ) {
    this.clientStore
      .getClient()
      .pipe(
        tap((client: ClientModel) => {
          this.clientName = client.personalData.firstName + ' ' + client.personalData.lastName;
          this.cd.detectChanges();
        }),
        take(1),
      )
      .subscribe();
  }

  public submit(): void {
    this.isDisabled = true;
    this.service
      .sendVerificationVideo()
      .pipe(
        take(1),
        catchError((error) => {
          this.isDisabled = false;
          return throwError(error);
        }),
        switchMap(() => this.clientStore.getClientIdentOptions(true)),
      )
      .subscribe();
  }
}
